import React from "react";
import BtnClose from "../../assets/images/btn-close.svg";

import diamondOne from "../../assets/images/diamond-1.png";

import emeraldOne from "../../assets/images/emerald-1.png";
import emeraldTwo from "../../assets/images/emerald-2.png";
import emeraldThree from "../../assets/images/emerald-3.png";

import pearlOne from "../../assets/images/pearl-1.png";
import pearlTwo from "../../assets/images/pearl-2.png";
import pearlThree from "../../assets/images/pearl-3.png";

import goldOne from "../../assets/images/gold-1.png";
import goldTwo from "../../assets/images/gold-2.png";
import goldThree from "../../assets/images/gold-3.png";
import goldFour from "../../assets/images/gold-4.png";
import goldFive from "../../assets/images/gold-5.png";
import goldSix from "../../assets/images/gold-6.png";
import goldSeven from "../../assets/images/gold-7.png";
import goldEight from "../../assets/images/gold-8.png";
import goldNine from "../../assets/images/gold-9.png";
import goldTen from "../../assets/images/gold-10.png";


import "./sponserPopup.scss";

export const SponserPopup = (props) => {
  // const [userDropdown, setuserDropdown] = useState(false);

  return (
    <div
      className={props.sponserToggle ? "sponser-popup active" : "sponser-popup"}
    >
      <div className="sponser-sec">
        <button type="button" className="close" onClick={props.sponserHandler}>
          <img src={BtnClose} alt="" />
        </button>

        <div className="colm">
          <h6>DIAMOND SPONSORS</h6>
          <ul>
            <li>
              <img src={diamondOne} alt="" />
            </li>
          </ul>
        </div>

        <div className="colm">
          <h6>EMERALD SPONSORS</h6>
          <ul>
            <li>
              <img src={emeraldOne} alt="" />
            </li>
            <li>
              <img src={emeraldTwo} alt="" />
            </li>
            <li>
              <img src={emeraldThree} alt="" />
            </li>
          </ul>
        </div>

        <div className="colm">
          <h6>PEARL SPONSORS</h6>
          <ul>
            <li>
              <img src={pearlOne} alt="" />
            </li>
            <li>
              <img src={pearlTwo} alt="" />
            </li>
            <li>
              <img src={pearlThree} alt="" />
            </li>
          </ul>
        </div>

        <div className="colm goldCol">
          <h6>GOLD SPONSORS</h6>
          <ul>
            <li>
              <img src={goldOne} alt="" />
            </li>
            <li>
              <img src={goldTwo} alt="" />
            </li>
            <li>
              <img src={goldThree} alt="" />
            </li>
            <li>
              <img src={goldFour} alt="" />
            </li>
            <li>
              <img src={goldFive} alt="" />
            </li>
            <li>
              <img src={goldSix} alt="" />
            </li>
            <li>
              <img src={goldSeven} alt="" />
            </li>
            <li>
              <img src={goldEight} alt="" />
            </li>
            <li>
              <img src={goldNine} alt="" />
            </li>
            <li>
              <img src={goldTen} alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
